export class RolloutCredentialResponse {
  private static readonly ERROR_MESSAGES: [needle: string, message: string][] = [
    [
      "Invalid credentials provided",
      "We couldn't connect to your CRM with these credentials. Please double check your credentials and try again.",
    ],
    ["Failed to get access token", "The API token is invalid or expired. Please try again."],
    ["Test failed", "The API token is invalid. Please try again."],
    ["appKey", "The app key is invalid. Please try again."],
  ];

  private static readonly DEFAULT_MESSAGE =
    "Something went wrong! We've been notified and will reach out to you shortly.";

  static getFriendlyErrorMessage(response: { errors: { message: string }[] }): string {
    const rawErrorMessage = response.errors?.[0]?.message ?? "";
    console.error("Rollout error:", rawErrorMessage);

    const match = RolloutCredentialResponse.ERROR_MESSAGES.find(([needle]) =>
      rawErrorMessage.toLowerCase().includes(needle.toLowerCase()),
    );

    return match ? match[1] : RolloutCredentialResponse.DEFAULT_MESSAGE;
  }
}
